__turbopack_context__.v({
  "clearButton": "LeftDrawer-module__vVqP-a__clearButton",
  "drawer": "LeftDrawer-module__vVqP-a__drawer",
  "drawerRow": "LeftDrawer-module__vVqP-a__drawerRow",
  "emptyStateMessage": "LeftDrawer-module__vVqP-a__emptyStateMessage",
  "emptyStateText": "LeftDrawer-module__vVqP-a__emptyStateText",
  "emptyStateTitle": "LeftDrawer-module__vVqP-a__emptyStateTitle",
  "expandToggle": "LeftDrawer-module__vVqP-a__expandToggle",
  "noteItem": "LeftDrawer-module__vVqP-a__noteItem",
  "notesSection": "LeftDrawer-module__vVqP-a__notesSection",
  "rowEnergy": "LeftDrawer-module__vVqP-a__rowEnergy",
  "rowLabel": "LeftDrawer-module__vVqP-a__rowLabel",
  "rowMinusButton": "LeftDrawer-module__vVqP-a__rowMinusButton",
});
